module.exports = "<p>\n  display-parent works!\n</p>\n"